











import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { Link } from '@/models/link'
import LinkItem from '@/components/Link/LinkItem.vue'

@Component({
  components: {
    LinkItem
  }
})
export default class LinkPage extends Vue {
  @Getter
  links!: Link[]
  @Prop({ type: String, required: true })
  slug!: string

  get link() {
    return this.links.find((link) => link.slug === this.slug)
  }
}
